"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _Text = require("./Text.styles");
var _typography = require("../../theme/base/typography");
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
// Create list of commonly used html text elements
var asOptions = (0, _freeze["default"])({
  bold: 'b',
  strong: 'strong',
  italic: 'i',
  emphasis: 'em',
  small: 'small',
  strikethrough: 's',
  underline: 'u'
});

/**
 * ### `combineAsWithVariant`
 * A function that takes in the `as` value (the HTML element to render the Text component as), and the
 * `variant` value. The default-like styling for the `as` prop is merged with the styling from the
 * `variant` and a combined styleProp object is returned.
 *
 * By default the `as` property only effects the underlying semantics of the markup, whereas the
 * `variant` only effects the visual styling of the text. In order for the text component to be built
 * with accessibility and ease-of-use in mind, these two properties _should_ be interconnected. Having
 * the style and markup unified allows an experience that is accessible to those using screen-readers
 * (or any other assistive technology) that matches (or is at least a close approximation) of the
 * "standard" visual experience.
 *
 * @function combineAsWithVariant
 * @param {string} args.as - The HTML element to render the Text component as
 * @param {string} args.variant - The style variant for the Text component
 * @returns {Object} An object containing the merged styleProps from the `variant` and the `as` props
 */

var combineAsWithVariant = function combineAsWithVariant(_ref) {
  var as = _ref.as,
    variant = _ref.variant;
  var variantFontSizeBase = Number(_Text.variants["".concat(variant)].fontSize.base.replace('rem', ''));
  var variantFontSizeDesktop = Number(_Text.variants["".concat(variant)].fontSize.desktop.replace('rem', ''));
  var styleProps;
  switch (as) {
    case asOptions.bold:
      styleProps = _objectSpread(_objectSpread({}, _Text.variants["".concat(variant)]), {}, {
        fontWeight: _typography.fontWeights.semibold
      });
      break;
    case asOptions.strong:
      styleProps = _objectSpread(_objectSpread({}, _Text.variants["".concat(variant)]), {}, {
        fontWeight: _typography.fontWeights.semibold
      });
      break;
    case asOptions.italic:
      styleProps = _objectSpread(_objectSpread({}, _Text.variants["".concat(variant)]), {}, {
        fontStyle: 'italic'
      });
      break;
    case asOptions.emphasis:
      styleProps = _objectSpread(_objectSpread({}, _Text.variants["".concat(variant)]), {}, {
        fontStyle: 'italic'
      });
      break;
    case asOptions.underline:
      styleProps = _objectSpread(_objectSpread({}, _Text.variants["".concat(variant)]), {}, {
        textDecoration: 'underline'
      });
      break;
    case asOptions.strikethrough:
      styleProps = _objectSpread(_objectSpread({}, _Text.variants["".concat(variant)]), {}, {
        textDecoration: 'line-through'
      });
      break;
    case asOptions.small:
      styleProps = _objectSpread(_objectSpread({}, _Text.variants["".concat(variant)]), {}, {
        fontSize: {
          base: "".concat(variantFontSizeBase * 0.8, "rem"),
          desktop: "".concat(variantFontSizeDesktop * 0.8, "rem")
        }
      });
      break;
    default:
      styleProps = _objectSpread({}, _Text.variants["".concat(variant)]);
      break;
  }
  return styleProps;
};
var _default = exports["default"] = combineAsWithVariant;